import strings from 'strings';

export const COPIES = strings.ai.generators.prospectingAssistant.drawer;

export const AI_PROSPECTING_ASSISTANT_BASE_PATH = 'ai/candidates-sourcing';
